import React from 'react'

const LoginTrouble = () => (
  <div className="container">
    <div className="LogintroubleSolution">
      <h1 className="main_head">Browser Requirements and Basic Troubleshooting Guide</h1>
      <div className="col-xs-12 pbottom_100">
        <h3 className="heading">Supported browsers</h3>
        <p>
          While most modern browsers will allow you to use the entire site without any
          problems, we specifically test and support:
        </p>
        <ul className="pad_0_40">
          <li className="pbottom_5">Chrome® – latest version (preferred browser)</li>
          <li className="pbottom_5">Firefox® – latest version</li>
          <li className="pbottom_5">Safari® 11+</li>
          <li className="pbottom_5">Internet Explorer® 11</li>
        </ul>

        <h3 className="heading">Enable JavaScript in your browser</h3>
        <p>
          JavaScript must be enabled in your browser in order to use ownersedge.us. All
          major browsers support JavaScript. Please refer{' '}
          <a href="#enableJS">section 4</a> to check if JavaScript is enabled in your
          browser and the steps to enable the same if not enabled.
        </p>

        <h3 className="heading">Troubleshooting FAQs</h3>
        <p>
          If you are unable to login into the application and are experiencing issues like
          the login button keeps spinning or nothing happens, please try the following in
          the mentioned order.
        </p>
        <div className="">
          <div className="margin_20_0">
            <h4 className="faqs">1. Refreshing the browser page</h4>
            <p className="mleft_15">
              Refreshing the browser (hard refresh) could solve the problem. Please try
              refreshing the browser by hitting{' '}
              <span className="f_bold"> CNRTL + SHIFT + F5 </span>
              (if you are using a <span className="f_bold">Windows </span> machine) or
              <span className="f_bold"> CMD + SHIFT + R</span> (if you are using a{' '}
              <span className="f_bold">MAC</span>).
            </p>
          </div>
          <div className="margin_20_0">
            <h4 className="faqs">2. Trying a different browser</h4>
            <p className="mleft_15">
              Please check if your browser and the version is under the supported browser
              versions. However, open a different browser and try to login with your
              credentials.
            </p>
          </div>
          <div className="margin_20_0">
            <h4 className="faqs">3. Clearing the cookies and cache</h4>
            <p className="mleft_15">
              Try clearing the cache and cookies from the browser. The steps to clear the
              cache and cookies for each browser is given below.
            </p>
            <ul className="no_bullets mleft_15">
              <li>For Chrome:</li>
              <p>
                <a href="https://support.google.com/accounts/answer/32050?co=GENIE.Platform%3DDesktop&hl=en">
                  https://support.google.com/accounts/answer/32050?co=GENIE.Platform%3DDesktop&hl=en
                </a>
              </p>

              <li>
                For Firefox:
                <p>
                  <a href="https://support.mozilla.org/en-US/kb/clear-cookies-and-site-data-firefox#w_clear-all-cookies-site-data-and-cache">
                    https://support.mozilla.org/en-US/kb/clear-cookies-and-site-data-firefox#w_clear-all-cookies-site-data-and-cache
                  </a>
                </p>
              </li>

              <li>For Safari:</li>
              <p>
                <a href="https://kb.wisc.edu/helpdesk/page.php?id=45060">
                  https://kb.wisc.edu/helpdesk/page.php?id=45060
                </a>
              </p>

              <li>For Internet Explorer:</li>
              <p>
                <a href="https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies">
                  https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies
                </a>
              </p>
            </ul>
          </div>
          <div className="margin_20_0">
            <h4>
              <a name="enableJS" className="faqs">
                {' '}
                4. Enabling JavaScript in your browser{' '}
              </a>
            </h4>
            <p className="mleft_15">
              JavaScript must be enabled in your browser to use ownersedge.us. To enable
              JavaScript, please follow the below steps (choose based on the browser that
              you are using).
            </p>
            <ul className="no_bullets mleft_15">
              <li>For Chrome:</li>
              <p>
                <a href="https://support.google.com/adsense/answer/12654?hl=en">
                  https://support.google.com/adsense/answer/12654?hl=en
                </a>
              </p>

              <li>For Firefox:</li>
              <p>
                <a href="http://static.webex.co.in/no-javascript/nojavascript-firefox.html">
                  http://static.webex.co.in/no-javascript/nojavascript-firefox.html
                </a>
              </p>

              <li>For Safari:</li>
              <p>
                <a href="https://www.whatismybrowser.com/guides/how-to-enable-javascript/safari">
                  https://www.whatismybrowser.com/guides/how-to-enable-javascript/safari
                </a>
              </p>

              <li>For Internet Explorer:</li>
              <p>
                <a href="https://www.whatismybrowser.com/guides/how-to-enable-javascript/internet-explorer">
                  https://www.whatismybrowser.com/guides/how-to-enable-javascript/internet-explorer
                </a>
              </p>
            </ul>
          </div>
          <div className="margin_20_0">
            <h4 className="faqs">5. Disabling ad blockers</h4>
            <p className="mleft_15">
              Sometimes if the ad blockers are enabled in the browser, the application may
              not work as intended. It is recommended to disable the ad blockers in the
              browser.
            </p>
            <ul className="no_bullets mleft_15">
              <li>For Chrome:</li>
              <p>
                <a href="https://support.google.com/chrome/answer/7632919?co=GENIE.Platform%3DDesktop&hl=en">
                  https://support.google.com/chrome/answer/7632919?co=GENIE.Platform%3DDesktop&hl=en
                </a>
              </p>

              <li>For other browsers:</li>
              <p>
                There is no inbuilt ad blockers for the other browsers. If any specific
                plug-in like AdBlock is installed in your browser, it has to be removed or
                disabled.
              </p>
            </ul>
          </div>
          <div className="margin_20_0">
            <h4 className="faqs">6. Logging in from a different device</h4>
            <p className="mleft_15">
              Try to login with a different device such as your home computer or mobile
              phone. While you are doing this, please ensure that you connect using a
              different Internet connection other than your office WiFi.
            </p>
            <p className="mleft_15">
              In case you are unable to login, please contact our Underwriters through an
              email immediately
            </p>
            <p className="mleft_15">
              If you are able to login in a different device, it could be due to firewall
              restrictions imposed by your Organization’s IT department. Please contact
              our Underwriters through an email immediately, so that our IT team can get
              in touch with your organization’s IT team to resolve the issue
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default LoginTrouble
